<template>
  <v-container v-if="user" fluid>
    <v-card class="pa-3">
      <v-card-title>
        Odoo
        <v-spacer />
      </v-card-title>
      <v-row>
        <v-col>
          <v-btn
            :class="[
              {
                'disabled-button': currentView != 'OdooView',
                'enabled-button': currentView === 'OdooView',
              },
              'mr-1',
              'ml-3',
              'mb-3',
            ]"
            color="primary"
            @click="currentView = 'OdooView'"
          >
            Productos
          </v-btn>

          <v-btn
            :class="[
              {
                'disabled-button': currentView != 'PreciosOdooView',
                'enabled-button': currentView === 'PreciosOdooView',
              },
              'mr-1',
              'ml-3',
              'mb-3',
            ]"
            color="primary"
            @click="currentView = 'PreciosOdooView'"
          >
            Precios
          </v-btn>

          <v-btn
            :class="[
              {
                'disabled-button': currentView != 'ClientesOdooView',
                'enabled-button': currentView === 'ClientesOdooView',
              },
              'mr-1',
              'ml-3',
              'mb-3',
            ]"
            color="primary"
            @click="currentView = 'ClientesOdooView'"
          >
            Clientes
          </v-btn>
        </v-col>
      </v-row>
      <PreciosOdooView v-if="currentView === 'PreciosOdooView'" />
      <ClientesOdooView v-if="currentView === 'ClientesOdooView'" />
      <!--
      <AsignacionesView v-if="currentView === 'AsignacionesView'" />
      <PerfilesView v-if="currentView === 'PerfilesView'" />
      -->
      <v-card v-if="currentView === 'OdooView'">
        <v-card-title class="text-center teal lighten-3 accent-4 white--text">
          Productos
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Búsqueda"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <v-spacer />
          <v-btn
            class="mr-7"
            color="primary"
            dark
            @click="dialogPaquetes = true"
          >
            Subir Paquetes
          </v-btn>
          <v-btn
            class="mr-7"
            color="primary"
            dark
            @click="dialogDescuentos = true"
          >
            Subir Descuentos
          </v-btn>
          <v-btn color="primary" dark @click="dialogExcel = true">
            Subir Excel
          </v-btn>
        </v-card-title>

        <v-dialog v-model="dialogPaquetes" max-width="520">
          <v-card>
            <v-card-title class="headline">Subir Paquetes</v-card-title>
            <v-card-text>
              <v-file-input
                v-model="excelFilePaquetes"
                accept=".xlsx, .xls"
                label="Selecciona un archivo Excel"
                prepend-icon="mdi-file-excel"
                dense
                show-size
                :disabled="loadingExcelPaquetes"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                text
                @click="dialogPaquetes = false"
                :disabled="loadingExcelPaquetes"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                :disabled="!excelFilePaquetes || loadingExcelPaquetes"
                @click="subirExcelPaquetes"
                :loading="loadingExcelPaquetes"
              >
                Subir
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDescuentos" max-width="520">
          <v-card>
            <v-card-title class="headline">Subir Descuentos</v-card-title>
            <v-card-text>
              <v-file-input
                v-model="excelFileDescuentos"
                accept=".xlsx, .xls"
                label="Selecciona un archivo Excel"
                prepend-icon="mdi-file-excel"
                dense
                show-size
                :disabled="loadingExcelDescuentos"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                text
                @click="dialogDescuentos = false"
                :disabled="loadingExcelDescuentos"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                :disabled="!excelFileDescuentos || loadingExcelDescuentos"
                @click="subirExcelDescuentos"
                :loading="loadingExcelDescuentos"
              >
                Subir
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogExcel" max-width="520">
          <v-card>
            <v-card-title class="headline">Subir Excel</v-card-title>
            <v-card-text>
              <v-file-input
                v-model="excelFile"
                accept=".xlsx, .xls"
                label="Selecciona un archivo Excel"
                prepend-icon="mdi-file-excel"
                dense
                show-size
                :disabled="loadingExcel"
              />
              <div v-if="loadingExcel" class="mt-4">
                <div class="d-flex justify-space-between align-center mb-2">
                  <span class="font-weight-bold">Subiendo...</span>
                  <span class="font-weight-bold"
                    >{{ uploadProgress.current }} de
                    {{ uploadProgress.total }}</span
                  >
                </div>
                <v-progress-linear
                  :value="(uploadProgress.current / uploadProgress.total) * 100"
                  color="primary"
                  height="8"
                />
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn text @click="dialogExcel = false" :disabled="loadingExcel">
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                :disabled="!excelFile || loadingExcel"
                @click="submitExcelFile"
                :loading="loadingExcel"
              >
                Subir
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogResults" max-width="700">
          <v-card>
            <v-card-title class="headline">Resultados de la Carga</v-card-title>
            <v-card-text>
              <div class="mb-4">
                <v-chip color="green" text-color="white" class="mr-2">
                  Exitosos: {{ resultsData.successful.length }}
                </v-chip>
                <v-chip
                  v-if="resultsData.errors.length > 0"
                  color="red"
                  text-color="white"
                >
                  Errores: {{ resultsData.errors.length }}
                </v-chip>
              </div>

              <v-row class="mb-4">
                <v-col cols="12" sm="6">
                  <v-checkbox
                    v-model="showResultSuccessful"
                    label="Mostrar correctos"
                    color="green"
                  />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-checkbox
                    v-model="showResultErrors"
                    label="Mostrar errores"
                    color="red"
                  />
                </v-col>
              </v-row>
              <v-data-table
                v-if="filteredResults.length"
                :headers="resultHeaders"
                :items="filteredResults"
                class="elevation-1"
                :items-per-page="15"
                :footer-props="{
                  'items-per-page-text': 'Resultados por página',
                }"
                :header-props="{
                  'sort-by-text': 'Ordenar por',
                }"
              >
                <template v-slot:[`item.valor`]="{ item }">
                  {{ "$" + item.valor.toFixed(2) }}
                </template>
                <template v-slot:[`item.state`]="{ item }">
                  <v-chip
                    :color="item.state === 'Correcto' ? 'green' : 'red'"
                    dark
                    small
                  >
                    {{ item.state }}
                  </v-chip>
                </template>
              </v-data-table>

              <div v-else class="text-center grey--text">
                No hay registros de resultado para mostrar.
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="primary" @click="dialogResults = false">
                Cerrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-row>
          <v-col cols="12" class="d-flex justify-end">
            <v-menu transition="scale-transition" bottom right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mx-4 my-4"
                  color="#fffff"
                  elevation="5"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  Exportar Tabla
                  <v-icon class="ml-2">mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item class="my-2" @click="exportarTabla('csv')"
                  >Exportar CSV</v-list-item
                >
                <v-list-item class="my-2" @click="exportarTabla('xlsx')"
                  >Exportar xlsx</v-list-item
                >
              </v-list>
            </v-menu>
          </v-col>
        </v-row>

        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :items-per-page="15"
          :footer-props="{
            'items-per-page-text': 'Usuarios por página',
          }"
          :header-props="{
            'sort-by-text': 'Ordenar por',
          }"
        >
          <template v-slot:[`item.costo`]="{ item }">
            {{ formatearCosto(item.costo) }}
          </template>
        </v-data-table>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import ExcelJS from "exceljs";
import Papa from "papaparse";
import { mapGetters } from "vuex";
import PreciosOdooView from "./PreciosOdooView.vue";
import ClientesOdooView from "./ClientesOdooView.vue";
export default {
  components: {
    PreciosOdooView,
    ClientesOdooView,
  },

  data() {
    return {
      currentView: "OdooView",
      items: [],
      search: "",
      excelFile: null,
      excelFilePaquetes: null,
      dialogExcel: false,
      dialogPaquetes: false,
      loadingExcel: false,
      loadingExcelPaquetes: false,
      excelFileDescuentos: null,
      dialogDescuentos: false,
      loadingExcelDescuentos: false,
      uploadProgress: {
        current: 0,
        total: 0,
      },
      dialogResults: false,
      resultsData: {
        successful: [],
        errors: [],
      },
      resultsTable: [],
      showResultSuccessful: true,
      showResultErrors: true,
      resultHeaders: [
        { text: "ID de Producto", value: "idProducto" },
        { text: "Código de Producto", value: "productCode" },
        { text: "Campo", value: "campo" },
        { text: "Valor", value: "valor" },
        { text: "Estado", value: "state" },
      ],

      headers: [
        {
          text: "ID",
          value: "id",
        },
        {
          text: "Código",
          value: "codigo_producto",
        },
        {
          text: "Nombre",
          value: "nombre_producto",
        },
        {
          text: "Costo",
          value: "costo",
        },
        {
          text: "Precio",
          value: "precio",
        },

        {
          text: "Impuestos de Ventas",
          value: "impuestos_de_ventas",
        },
        {
          text: "Impuestos de Compras",
          value: "impuestos_de_compras",
        },
        {
          text: "Alternativas",
          value: "alternativas",
        },
        {
          text: "Etiquetas",
          value: "etiquetas",
        },
        {
          text: "Seguimiento",
          value: "seguimiento",
        },
      ],
    };
  },
  methods: {
    async getProductosOdoo() {
      try {
        const productos = await axios.get("/odoo/get_productos");

        const headers = productos.data.headers;
        const rows = productos.data.data;

        this.items = rows.map((row) => {
          let obj = {};
          headers.forEach((header, index) => {
            obj[header] = row[index];
          });
          return obj;
        });
      } catch (error) {
        console.error(error);
      }
    },

    async subirExcelPaquetes() {
      if (!this.excelFilePaquetes) {
        console.warn("Selecciona un archivo antes de subir.");
        return;
      }

      this.loadingExcelPaquetes = true;
      try {
        const formData = new FormData();
        formData.append(
          "file",
          this.excelFilePaquetes,
          this.excelFilePaquetes.name,
        );
        formData.append("return_file", "true");

        const response = await axios.post("/odoo/paquetes", formData, {
          responseType: "blob",
        });

        const contentDisposition =
          response.headers["content-disposition"] || "";
        const contentType = response.headers["content-type"] || "";
        const fileNameMatch = contentDisposition.match(
          /filename\*=UTF-8''(.+)|filename="?([^";]+)"?/i,
        );
        let isCsv =
          contentType.toLowerCase().includes("csv") ||
          contentDisposition.toLowerCase().includes("csv");
        const defaultExtension = isCsv ? "csv" : "xlsx";
        let fileName = fileNameMatch
          ? decodeURIComponent(fileNameMatch[1] || fileNameMatch[2])
          : `paquetes-${new Date()
              .toISOString()
              .slice(0, 10)}.${defaultExtension}`;

        if (!isCsv && fileName.toLowerCase().includes(".csv")) {
          isCsv = true;
        }

        if (!isCsv && response.data && response.data.size) {
          const previewText = await response.data.slice(0, 512).text();
          const looksLikeCsv =
            previewText.includes("\n") &&
            (previewText.includes(",") || previewText.includes(";"));
          if (looksLikeCsv) {
            isCsv = true;
          }
        }

        if (isCsv && fileName.toLowerCase().endsWith(".xlsx")) {
          fileName = fileName.replace(/\.xlsx$/i, ".csv");
        }

        if (!fileName.match(/\.[^/.]+$/)) {
          fileName = `${fileName}.${isCsv ? "csv" : "xlsx"}`;
        }

        const blob = new Blob([response.data], {
          type:
            contentType ||
            (isCsv
              ? "text/csv;charset=utf-8"
              : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"),
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        this.dialogPaquetes = false;
        this.excelFilePaquetes = null;
      } catch (error) {
        console.error("Error al subir paquetes:", error);
      } finally {
        this.loadingExcelPaquetes = false;
      }
    },
    async subirExcelDescuentos() {
      if (!this.excelFileDescuentos) {
        console.warn("Selecciona un archivo antes de subir.");
        return;
      }

      this.loadingExcelDescuentos = true;
      try {
        const formData = new FormData();
        formData.append(
          "file",
          this.excelFileDescuentos,
          this.excelFileDescuentos.name,
        );
        formData.append("return_file", "true");

        const response = await axios.post("/odoo/descuentos", formData, {
          responseType: "blob",
        });

        const contentDisposition =
          response.headers["content-disposition"] || "";
        const contentType = response.headers["content-type"] || "";
        const fileNameMatch = contentDisposition.match(
          /filename\*=UTF-8''(.+)|filename="?([^";]+)"?/i,
        );
        let isCsv =
          contentType.toLowerCase().includes("csv") ||
          contentDisposition.toLowerCase().includes("csv");
        const defaultExtension = isCsv ? "csv" : "xlsx";
        let fileName = fileNameMatch
          ? decodeURIComponent(fileNameMatch[1] || fileNameMatch[2])
          : `descuentos-${new Date()
              .toISOString()
              .slice(0, 10)}.${defaultExtension}`;

        if (!isCsv && fileName.toLowerCase().includes(".csv")) {
          isCsv = true;
        }

        if (!isCsv && response.data && response.data.size) {
          const previewText = await response.data.slice(0, 512).text();
          const looksLikeCsv =
            previewText.includes("\n") &&
            (previewText.includes(",") || previewText.includes(";"));
          if (looksLikeCsv) {
            isCsv = true;
          }
        }

        if (isCsv && fileName.toLowerCase().endsWith(".xlsx")) {
          fileName = fileName.replace(/\.xlsx$/i, ".csv");
        }

        if (!fileName.match(/\.[^/.]+$/)) {
          fileName = `${fileName}.${isCsv ? "csv" : "xlsx"}`;
        }

        const blob = new Blob([response.data], {
          type:
            contentType ||
            (isCsv
              ? "text/csv;charset=utf-8"
              : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"),
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        this.dialogDescuentos = false;
        this.excelFileDescuentos = null;
      } catch (error) {
        console.error("Error al subir descuentos:", error);
      } finally {
        this.loadingExcelDescuentos = false;
      }
    },

    submitExcelFile() {
      if (!this.excelFile) {
        console.warn("Selecciona un archivo antes de subir.");
        return;
      }
      this.uploadExcelFile(this.excelFile);
    },

    async uploadExcelFile(file) {
      this.loadingExcel = true;
      try {
        const workbook = new ExcelJS.Workbook();
        const arrayBuffer = await file.arrayBuffer();
        await workbook.xlsx.load(arrayBuffer);

        const worksheet = workbook.worksheets[0];
        if (!worksheet) {
          throw new Error("El archivo Excel no tiene ninguna hoja.");
        }

        const headerRow = worksheet.getRow(1);
        const headers = headerRow.values
          .slice(1)
          .map((value) => String(value || "").trim());
        if (headers.length < 2) {
          throw new Error(
            "El Excel debe tener al menos columna de producto y una columna de valor.",
          );
        }

        const productByCode = this.items.reduce((map, item) => {
          const code = String(item.codigo_producto || "").trim();
          if (code) {
            map[code] = item.id;
          }
          return map;
        }, {});

        const requests = [];
        const requestMetadata = [];
        let missingProducts = 0;

        worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
          if (rowNumber === 1) {
            return;
          }

          const rowValues = row.values
            .slice(1)
            .map((value) =>
              value === undefined || value === null ? "" : value,
            );
          const productCode = String(rowValues[0] || "").trim();
          const idProducto = productByCode[productCode];

          if (!productCode || !idProducto) {
            missingProducts += 1;
            return;
          }

          for (
            let columnIndex = 1;
            columnIndex < headers.length;
            columnIndex += 1
          ) {
            const campo = headers[columnIndex];
            const valor = rowValues[columnIndex];
            if (valor === "" || valor === null || valor === undefined) {
              continue;
            }

            const metadata = { idProducto, productCode, campo, valor };
            requestMetadata.push(metadata);
            requests.push(
              axios
                .post(
                  `/odoo/actualizar_producto?id_producto=${idProducto}&campo=${campo}&valor=${valor}`,
                )
                .then(() => {
                  this.uploadProgress.current += 1;
                }),
            );
          }
        });

        if (requests.length === 0) {
          console.warn(
            "No se encontraron valores para enviar en el archivo Excel.",
          );
          return;
        }

        this.uploadProgress.total = requests.length;
        this.uploadProgress.current = 0;

        const results = await Promise.allSettled(requests);
        this.resultsData = { successful: [], errors: [] };
        this.resultsTable = [];

        results.forEach((result, index) => {
          const metadata = requestMetadata[index];
          if (result.status === "fulfilled") {
            const row = { ...metadata, state: "Correcto" };
            this.resultsData.successful.push(metadata);
            this.resultsTable.push(row);
          } else {
            const row = {
              ...metadata,
              state: "Error",
              message: result.reason?.message || "Error desconocido",
            };
            this.resultsData.errors.push(row);
            this.resultsTable.push(row);
          }
        });

        console.info(
          `Excel procesado: ${this.resultsData.successful.length} exitosos, ${this.resultsData.errors.length} errores, ${missingProducts} filas sin producto válido.`,
        );
      } catch (error) {
        console.error("Error al procesar el Excel:", error);
      } finally {
        this.excelFile = null;
        this.loadingExcel = false;
        this.uploadProgress = { current: 0, total: 0 };
        this.dialogExcel = false;
        this.dialogResults = true;
        await this.getProductosOdoo();
      }
    },

    async exportarTabla(formato) {
      // Exportar exactamente lo que se ve en la tabla principal
      const exportHeaders = this.headers;
      const headerSinAcentos = exportHeaders.map((header) => ({
        text: header.text.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
        value: header.value,
      }));
      const exportData = this.items.map((item) => {
        const row = {};
        headerSinAcentos.forEach((header) => {
          let value = item[header.value];
          // Si es array, lo convertimos a string separado por coma
          if (Array.isArray(value)) {
            value = value.join(", ");
          }
          row[header.text] = value;
        });
        return row;
      });

      if (formato === "csv") {
        const csvData = Papa.unparse(exportData);
        const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "ProductosOdoo.csv";
        link.click();
        URL.revokeObjectURL(url);
      } else if (formato === "xlsx") {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Productos");

        worksheet.columns = [
          { header: "ID", key: "ID", width: 10 },
          { header: "Código", key: "Código", width: 20 },
          { header: "Nombre", key: "Nombre", width: 30 },
          { header: "Costo", key: "Costo", width: 15 },
          { header: "Precio", key: "Precio", width: 15 },
          {
            header: "Impuestos de Ventas",
            key: "Impuestos de Ventas",
            width: 25,
          },
          {
            header: "Impuestos de Compras",
            key: "Impuestos de Compras",
            width: 25,
          },
          { header: "Alternativas", key: "Alternativas", width: 20 },
          { header: "Etiquetas", key: "Etiquetas", width: 20 },
          { header: "Seguimiento", key: "Seguimiento", width: 20 },
        ];
        worksheet.addRows(exportData);
        workbook.xlsx.writeBuffer().then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "ProductosOdoo.xlsx";
          link.click();
          URL.revokeObjectURL(url);
        });
      }
    },

    getColor(estado) {
      return estado ? "green" : "red";
    },

    formatearCosto(costo) {
      const moneda = new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
      });
      return moneda.format(costo);
    },
  },
  created() {
    this.getProductosOdoo();
  },
  computed: {
    ...mapGetters(["user"]),
    filteredResults() {
      return this.resultsTable.filter((item) => {
        if (item.state === "Correcto" && this.showResultSuccessful) {
          return true;
        }
        if (item.state === "Error" && this.showResultErrors) {
          return true;
        }
        return false;
      });
    },
  },
};
</script>
